import { useEffect, useState } from 'react';

export const useImageState = ({ itemId }) => {
  const [imageState, setImageState] = useState('loading');

  useEffect(() => {
    setImageState('loading');
  }, [itemId]);

  return { imageState, setImageState };
};
